"use client";

import React, { useEffect, useRef } from "react";
import { useRouter } from "next/navigation";

export default function CtaSection() {
  const sectionRef = useRef<HTMLDivElement>(null);
  const router = useRouter();

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) e.target.classList.add("is-visible");
        });
      },
      { threshold: 0 }
    );
    sectionRef?.current?.querySelectorAll(".reveal-hidden")?.forEach((el) => observer?.observe(el));
    return () => observer?.disconnect();
  }, []);

  return (
    <section
      ref={sectionRef}
      className="section-pad relative overflow-hidden bg-white">
      <div className="max-w-3xl mx-auto px-6 md:px-12 text-center relative z-10">

        {/* Eyebrow */}
        <div className="reveal-hidden mb-5">
          <p className="text-xs font-medium uppercase tracking-widest text-pmu-taupe" style={{ letterSpacing: "0.2em" }}>READY FOR A PICK ME UP?

          </p>
        </div>

        {/* Headline */}
        <div className="reveal-hidden delay-1 mb-5">
          <h2
            className="font-fraunces font-bold text-pmu-espresso leading-tight"
            style={{ fontSize: "clamp(2.2rem, 5vw, 3.5rem)" }}>

            Your next favorite cookie{" "}
            <span className="italic font-light" style={{ color: "#A8C4D8" }}>is plant-based</span>
          </h2>
        </div>

        {/* Supporting copy */}
        <div className="reveal-hidden delay-2 mb-10">
          <p className="text-base text-pmu-taupe leading-relaxed max-w-xl mx-auto" style={{ fontWeight: 400 }}>One bite and you'll understand why.


          </p>
        </div>

        {/* CTA Buttons */}
        <div className="reveal-hidden delay-3 flex flex-col sm:flex-row items-center justify-center gap-3 mb-10">
          <button className="btn-primary" onClick={() => router?.push("/purchase")}>
            Order Pick Me Up
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M5 12h14M12 5l7 7-7 7" />
            </svg>
          </button>
          <button className="btn-secondary" onClick={() => router?.push("/our-story")}>
            Learn Our Story
          </button>
        </div>

        {/* Attribute badges */}
        <div className="reveal-hidden delay-4 flex flex-wrap items-center justify-center gap-2">
          {[
          "100% Vegan",
          "Gluten-Free",
          "9g Protein",
          "4g Fibre",
          "Ships Free"]?.
          map((label) =>
          <span key={label} className="ingredient-tag">
              {label}
            </span>
          )}
        </div>
      </div>
    </section>
  );

}